import { GetTreatyClaim_getTreatyClaim } from "_graphql/queries/__generated__/GetTreatyClaim";
import { GetTreatyClaimShare_getTreatyClaimShare } from "_graphql/queries/__generated__/GetTreatyClaimShare";
import _ from "lodash";
import { FC } from "react";

type Props = {
  share: GetTreatyClaimShare_getTreatyClaimShare | null | undefined;
};

const TreatyClaimShareView: FC<Props> = ({ share }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      {/* {JSON.stringify(claim?.treaty_claim_details, null, 2)} */}
      <div>
        <span className="text-xs font-light">Claim Share Information</span>
        <div className="grid grid-cols-3 gap-6 mt-2">
          <div className="col-span-2">
            <span className="block text-sm font-light text-gray-700">
              Reinsurer
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {share?.reinsurer || "N/A"}
            </div>
          </div>
          <div className=" gap-6 mt-2">
            <div>
              <span className="block text-sm font-light text-gray-700">
                Participating %
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {share?.percentage ? `${share.percentage}%` : "N/A"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-6">
        <span className="text-xs font-light">claim Details</span>
        <div className="grid grid-cols-3 gap-6 mt-2">
          <div>
            <span className="block text-sm font-light text-gray-700">
              Claim Paid
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {share?.claim_paid || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Share of Claim Amount
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {share?.claim_payment_share || "N/A"}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default TreatyClaimShareView;
